module.exports = __webpack_public_path__ + "static/media/add-contact-icon.c322f826.svg";